import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Reviews } from 'src/models/DTO/reviews/reviewCollection';
import { Config } from '../../../infrastructure/config';
import { CreateReviewRequestModel } from '../../../models/requestModels/reviews/createReviewRequestModel';

@Injectable({
  providedIn: 'root'
})
export class ReviewsService {


  private reviewsURL : string = Config.api + "product/";


  constructor(private httpClient: HttpClient) { }

  getProductReviews(productUUID: string, page: number, perPage: number = Config.defaultItemsPerPage, sorter: string = 'newest') {
    const params = productUUID + "/reviews?include=user&fields[user]=uuid,first_name,last_name,email&perPage=" + perPage + '&page=' + page + '&sort=' + sorter;
    return this.httpClient.get<Reviews>(this.reviewsURL + params);
  }


  postProductReview(productUUID: string, createReviewRequestModel: CreateReviewRequestModel) {
    const params = productUUID + "/reviews";
    return this.httpClient.post<Reviews>(this.reviewsURL + params, createReviewRequestModel);

    // return Http.request({
    //   url: this.reviewsURL,
    //   method: "POST",
    //   headers: HTTPManager.headers(),
    //   content: JSON.stringify(createReviewRequestModel),
    // });
  }
}
